var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-header-menu", style: { height: _vm.headerHeight } },
    [
      _c(
        "el-menu",
        {
          staticClass: "user_info_cla",
          attrs: { mode: "horizontal" },
          on: { select: _vm.handleSelect }
        },
        [
          _c(
            "el-submenu",
            { staticClass: "submenu_cla", attrs: { index: "2" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.loginName) +
                    "\n                "
                ),
                _c("i", { staticClass: "zk-icon-users" })
              ]),
              _vm._v(" "),
              _c(
                "el-menu-item",
                { attrs: { index: "modifyPwd" } },
                [
                  _vm._t("modifyPwd", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("account.modifyPwd")) +
                        "\n              "
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                { attrs: { index: "loginout" } },
                [
                  _vm._t("loginout", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("account.loginOut")) +
                        "\n              "
                    )
                  ])
                ],
                2
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("zk-modify-pwd", {
        attrs: { dialogVisible: _vm.dialogVisible },
        on: {
          close: function($event) {
            _vm.dialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60355be1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60355be1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/loginUserInfo/src/main.vue
// module id = null
// module chunks = 